import { WidgetKind, type Report } from 'corso-admin-ui';
import { itemsOverTime, productTables } from '../claimItems';

export const products = {
  key: 'products',
  label: 'Products',
  dataset: 'claimItems',
  timeFields: ['createdOn', 'finalizedOn'],
  widgets: [
    { kind: WidgetKind.kpi, title: 'Items returned', metric: 'items' },
    {
      kind: WidgetKind.kpi,
      title: 'Returned item price',
      metric: 'itemValue',
    },
    {
      kind: WidgetKind.kpi,
      title: 'Items per return request',
      metric: 'itemsPerClaim',
    },
    itemsOverTime,
    ...productTables,
  ],
} as const satisfies Report;
